import {
	CLEAR_INDUSTRY_MANAGEMENT_STATE,
	GET_ALL_INDUSTRYS,
	GET_ALL_INDUSTRYS_SUCCESS,
	GET_ALL_INDUSTRYS_ERROR,
	GET_INDUSTRY_BY_ID,
	GET_INDUSTRY_BY_ID_SUCCESS,
	GET_INDUSTRY_BY_ID_ERROR,
	CREATE_INDUSTRY,
	CREATE_INDUSTRY_SUCCESS,
	CREATE_INDUSTRY_ERROR,
	UPDATE_INDUSTRY,
	UPDATE_INDUSTRY_SUCCESS,
	UPDATE_INDUSTRY_ERROR,
	DELETE_INDUSTRY,
	DELETE_INDUSTRY_SUCCESS,
	DELETE_INDUSTRY_ERROR,
} from './actions';
import api from '@/utils/api';

const { http } = api.getInstance();
const INDUSTRY_URL = '/industryType';

const defaultState = () => ({
	industryList: [],
	isLoadingIndustry: '',
});

const state = defaultState();

const getters = {
	industryList: (state) => state.industryList,
	isLoadingIndustry: (state) => state.isLoadingIndustry === 'loading',
};

const mutations = {
	[CLEAR_INDUSTRY_MANAGEMENT_STATE]: (state) => {
		Object.assign(state, defaultState());
	},
	[GET_ALL_INDUSTRYS]: (state) => {
		state.isLoadingIndustry = 'loading';
	},
	[GET_ALL_INDUSTRYS_SUCCESS]: (state, data) => {
		state.industryList = data;
		state.isLoadingIndustry = 'success';
	},
	[GET_ALL_INDUSTRYS_ERROR]: (state) => {
		state.isLoadingIndustry = 'error';
	},
	[GET_INDUSTRY_BY_ID]: (state) => {
		state.isLoadingIndustry = 'loading';
	},
	[GET_INDUSTRY_BY_ID_SUCCESS]: (state, data) => {
		state.isLoadingIndustry = 'success';
	},
	[GET_INDUSTRY_BY_ID_ERROR]: (state) => {
		state.isLoadingIndustry = 'error';
	},
	[CREATE_INDUSTRY]: (state) => {
		state.isLoadingIndustry = 'loading';
	},
	[CREATE_INDUSTRY_SUCCESS]: (state) => {
		state.isLoadingIndustry = 'success';
	},
	[CREATE_INDUSTRY_ERROR]: (state) => {
		state.isLoadingIndustry = 'error';
	},
	[UPDATE_INDUSTRY]: (state) => {
		state.isLoadingIndustry = 'loading';
	},
	[UPDATE_INDUSTRY_SUCCESS]: (state, data) => {
		state.isLoadingIndustry = 'success';
	},
	[UPDATE_INDUSTRY_ERROR]: (state) => {
		state.isLoadingIndustry = 'error';
	},
	[DELETE_INDUSTRY]: (state) => {
		state.isLoadingIndustry = 'loading';
	},
	[DELETE_INDUSTRY_SUCCESS]: (state, data) => {
		state.isLoadingIndustry = 'success';
	},
	[DELETE_INDUSTRY_ERROR]: (state) => {
		state.isLoadingIndustry = 'error';
	},
};

const actions = {
	[GET_ALL_INDUSTRYS]: async ({ commit }, { vm, params }) => {
		return new Promise((resolve, reject) => {
			commit(GET_ALL_INDUSTRYS);
			localStorage.setItem(`lastReqAdm`, 'industryManagement/GET_ALL_INDUSTRYS');

			http({
				method: 'GET',
				url: `${INDUSTRY_URL}${params}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_ALL_INDUSTRYS_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_ALL_INDUSTRYS_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[GET_INDUSTRY_BY_ID]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(GET_INDUSTRY_BY_ID);

			http({
				method: 'GET',
				url: `${INDUSTRY_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					commit(GET_INDUSTRY_BY_ID_SUCCESS, response.data);
				})
				.catch((error) => {
					reject(error);
					commit(GET_INDUSTRY_BY_ID_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[CREATE_INDUSTRY]: async ({ commit }, { vm, body }) => {
		return new Promise((resolve, reject) => {
			commit(CREATE_INDUSTRY);

			http({
				method: 'POST',
				url: `${INDUSTRY_URL}/v2`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					commit(CREATE_INDUSTRY_SUCCESS);
					vm.$toastr.s('Indústria criada com sucesso.');
				})
				.catch((error) => {
					reject(error);
					commit(CREATE_INDUSTRY_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[UPDATE_INDUSTRY]: async ({ commit }, { vm, id, body }) => {
		return new Promise((resolve, reject) => {
			commit(UPDATE_INDUSTRY);

			http({
				method: 'PATCH',
				url: `${INDUSTRY_URL}/v2/${id}`,
				data: body,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Indústria editada com sucesso.');
					commit(UPDATE_INDUSTRY_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(UPDATE_INDUSTRY_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
	[DELETE_INDUSTRY]: async ({ commit }, { vm, id }) => {
		return new Promise((resolve, reject) => {
			commit(DELETE_INDUSTRY);

			http({
				method: 'DELETE',
				url: `${INDUSTRY_URL}/${id}`,
			})
				.then((response) => {
					resolve(response);
					vm.$toastr.s('Indústria excluída com sucesso.');
					commit(DELETE_INDUSTRY_SUCCESS);
				})
				.catch((error) => {
					reject(error);
					commit(DELETE_INDUSTRY_ERROR);
					vm.$toastr.e(error.response.data.message);
				});
		});
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
